<template>
  <div class="footer">
    <b-button variant="warning" size="lg" class="btn-offer" @click="$emit('cancel')">
      Close
    </b-button>
    <slot v-if="isConfirmButtonCustom" name="confirmButton"></slot>
    <b-button variant="success" size="lg" v-else class="btn-offer" @click="$emit('confirm')">
      Confirm
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'VModalFooter',
  props: {
    isConfirmButtonCustom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  justify-content: space-around;
  margin-top: 0.5em;

  button {
    width: 8em;
  }
}
</style>
